import { Navigate, useLocation } from 'react-router-dom'
import ContentPage from '@/components/ContentPage'
import { getSeoPage, seoPages } from '@/content/seoPages'

export default function SeoContentPage({ slug: slugProp }) {
  const { pathname } = useLocation()
  const slug =
    slugProp ||
    seoPages.find((p) => p.path === pathname)?.slug ||
    pathname.replace(/^\//, '')
  const page = getSeoPage(slug)

  if (!page) {
    return <Navigate to="/" replace />
  }

  return (
    <ContentPage
      path={page.path}
      seoTitle={page.seoTitle}
      seoDescription={page.seoDescription}
      heroTitle={page.title}
      heroDescription={page.intro}
      images={page.images}
      eyebrow={page.eyebrow}
      sections={page.sections}
      relatedFeatureSlugs={page.relatedFeatureSlugs}
      resourceLinks={page.resourceLinks || []}
      ctaTitle={page.ctaTitle}
      ctaDescription={page.ctaDescription}
      ctaButtonLabel={page.ctaButtonLabel}
    />
  )
}
